<!-- 销售单急件商品采购-->
<template>
    <div class="business-content-main urgentGoodsToPur" v-loading="searchApParams._visible" element-loading-spinner="none">
        <div>
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <div class="section-title">
                <div class="flex">
                    <span> 商品明细 </span>
                    <div style="margin-left: 10px">
                        <el-select
                            style="width: 200px"
                            size="small"
                            v-model="warehouseId"
                            :disabled="warehouseId != ''"
                            placeholder="请选择"
                            filterable
                            @visible-change="warehouseVisibleChange($event)"
                            @change="warehouseChange"
                        >
                            <el-option label="请选择仓库" value></el-option>
                            <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId">
                                <span style="float: left">{{ item.WarehouseName }}</span>
                                <span v-if="item.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div>
                    <el-button size="small" class="search-btn btn-primary" v-if="permission.saveTemp" :disabled="saving" @click="saveTemp()"
                        >{{ permission.saveTemp }} (F1)</el-button
                    >
                    <el-button size="small" class="search-btn btn-primary" @click="showSearch()">搜索配件 (F2)</el-button>
                    <el-button size="small" class="search-btn btn-primary" @click="submitForm()">创建采购订单</el-button>
                </div>
            </div>
        </div>

        <div id="infinite-list">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteTableHeight"
                :checkboxConfig="{ highlight: false }"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                show-summary
                :summary-method="setSummaries"
                :row-style="setRowStyle"
                highlight-current-row
                :row-class-name="tableRowClassName"
                @row-click="rowClick"
                @cell-click="cellClick"
            >
                <ux-table-column class-name="table-sort" type="index" field="Sort" title="序号" width="60"></ux-table-column>
                <ux-table-column field="EntpCusItem" key="EntpCusItem" title="供应商" min-width="80" edit-render show-overflow-tooltip>
                    <template v-slot:header="{ column }"> <span class="color-red">*</span> {{ column.title }} </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.EntpCusName }]" @click="focusHandle(rowIndex, 'custSelect')">{{ row.EntpCusName }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="custSelect"
                            style="width: 100%"
                            size="small"
                            v-model="scope.row.EntpCusItem"
                            value-key="EntpCusId"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            :remote-method="searchCustomer"
                            v-select-scroll-more="searchSupplierLoad"
                            placeholder="供应商"
                            @change="customerChange($event, scope.rowIndex)"
                            @visible-change="customerVisibleChange($event)"
                        >
                            <el-option
                                v-for="optionItem in customerList"
                                :key="optionItem.EntpCusId"
                                :data-msg="optionItem"
                                :label="optionItem.EntpCusName"
                                :value="optionItem"
                            ></el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="APCode" key="APCode" title="汽配编码" min-width="100" resizable show-overflow-tooltip>
                    <template v-slot="{ row }">
                        <div class="sales-apcode div-padding-12">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)" />
                            <span> {{ row.APCode }}</span>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodName" key="GoodName" title="配件名称" min-width="50" resizable show-overflow-tooltip>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.GoodName }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSerise" key="AutoSerise" title="车型" min-width="50" resizable show-overflow-tooltip>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.AutoSerise }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Brand" title="品牌" width="90" resizable key="Brand">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Brand }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Origin" title="产地" width="120" :edit-render="{ autofocus: '.el-input__inner' }" resizable key="origin">
                    <template v-slot="{ row }">
                        <div class="div-padding-12" @click="focusHandle(row.IsNew, row, 'originRef')">{{ row.Origin }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input ref="originRef" size="small" v-model="scope.row.Origin"></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Size" key="Size" title="规格" width="80">
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.Size }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="SalesPrice" key="SalesPrice" title="销售价" width="80">
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.SalesPrice }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Unit" key="Unit" title="单位" width="80">
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.Unit }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Count" key="Count" title="急件数" width="80">
                    <template v-slot="scope">
                        <div class="div-padding-12">{{ scope.row.Count }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Price" key="Price" title="采购价" width="115" edit-render>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                当配件已采购过时，显示配件最低供应商的最新采购价格；<br />
                                若配件从未向当前供应商采购过，则取配件的成本价格
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                <span class="color-red">*</span>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': !row.Price || row.Price === 0 }]">{{ row.Price }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                size="small"
                                style="width: 100%"
                                :min="0"
                                :precision="2"
                                :step="0.01"
                                controls-position="right"
                                v-model="scope.row.Price"
                                @input="priceChange"
                                placeholder="采购价"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="cgzj" key="cgzj" title="采购总价" width="90">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Price * row.Count ? (row.Price * row.Count).toFixed(2) : 0 }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="SaleOrderCode" key="SaleOrderCode" title="销售单号" width="150" resizable show-overflow-tooltip>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.SaleOrderCode }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" width="100">
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate">
                            <i v-if="showIconDelete" class="el-icon-delete" title="移除" @click="delItem(rowIndex)"></i>
                            <!-- <i v-if="showIconAdd(rowIndex)" class="el-icon-plus" title="添加" @click="addItem(true)"></i> -->
                            <img v-if="row.EntpTempGoodsId" class="image-sup" src="@/assets/images/sup.png" title="采购历史" @click="showHistories(row)" />
                            <img v-if="row.EntpTempGoodsId" class="image-cus" src="@/assets/images/cus.png" title="销售历史" @click="showSaleStat(row)" />
                            <!-- <img
                                v-if="row.EntpTempGoodsId"
                                src="@/assets/images/analysis.png"
                                style="width: 22px; height: 22px; margin-left: 4px"
                                title="数据分析"
                                @click="analysis(row)"
                            /> -->
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--   搜索配件    -->
        <el-dialog :close-on-click-modal="false" title="搜索配件" :visible.sync="searchVisible" width="1090px" style="margin-left: -220px">
            <div v-if="searchVisible">
                <searchUrgentGoods
                    @chooseAllAPsHandle="chooseAllAPsHandle"
                    @closeDialog="closeSearchDialog"
                    :SelectedData="selectedData"
                    :StorageId="warehouseId"
                    :warehouseName="warehouseName"
                    @setItemVisible="setItemVisible"
                    ref="searchDlg"
                ></searchUrgentGoods>
            </div>
        </el-dialog>
        <!--    采购历史    -->
        <el-dialog :close-on-click-modal="false" title="采购历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APPurchaseHistory
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusId="EntpCusId"
                    :EntpCusName="EntpCusName"
                    @closeDialog="
                        () => {
                            historyVisible = false;
                        }
                    "
                ></APPurchaseHistory>
            </div>
        </el-dialog>
        <!-- 销售历史 -->
        <el-dialog :title="SaleDialogTitle" :close-on-click-modal="false" :visible.sync="eyeHistoryVisible" append-to-body width="1200px">
            <div v-if="eyeHistoryVisible">
                <APHistory :showCusColumn="false" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="eyeHistoryVisible = false"></APHistory>
            </div>
        </el-dialog>
        <!-- 数据分析 -->
        <el-dialog :close-on-click-modal="false" title="商品销售采购数据图表" :visible.sync="goodsAnalysisVisible" width="1200px">
            <div class="dialog-content" v-if="goodsAnalysisVisible">
                <goodsAnalysis :GoodsId="EntpTempGoodsIdEdit" @closeDialog="goodsAnalysisVisible = false"></goodsAnalysis>
            </div>
        </el-dialog>
        <el-progress v-if="searchApParams._visible && searchApParams.showPerc" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
        <!-- 近三个月销售数据 -->
        <el-dialog
            :close-on-click-modal="false"
            :title="SalesDataTitle"
            width="600px"
            :visible.sync="SalesDataVisible"
            v-dialog-drag
            append-to-body
            lock-scroll
            :modal="false"
            id="ap-image-dialog"
            custom-class="image-item-dialog"
        >
            <div style="padding-top: 5px; padding-bottom: 10px" v-if="SalesDataVisible">
                <ux-grid :data="SalesDataList" border style="width: 100%" ref="salesDataTable">
                    <ux-table-column resizable :title="item" min-width="100px" v-for="(item, index) in SalesDataHeader" :key="index">
                        <template slot-scope="scope">
                            <span v-for="(item2, index2) in scope.row.list" v-show="index == index2" :key="index2">
                                {{ item2.Count }}
                            </span>
                        </template>
                    </ux-table-column>
                </ux-grid>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import searchUrgentGoods from '@/components/common/searchUrgentGoods';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
import APPurchaseHistory from '@/components/common/APPurchaseHistory';
import APHistory from '@/components/common/APHistory';
import goodsAnalysis from '@/components/common/goodsAnalysis';
export default {
    mixins: [mixin],
    name: '',
    components: {
        searchUrgentGoods,
        APMsg,
        breadcrumb,
        APPurchaseHistory,
        APHistory,
        goodsAnalysis
    },
    data() {
        return {
            isCheckCode: true,
            needConfirm: true,
            dataStorageName: 'AddUrgentGoodsPur_dataList',
            historyVisible: false,
            EntpTempGoodsIdEdit: '',
            APMsgVisible: false,
            searchVisible: false,
            searchItemVisible: false,
            saving: false,
            allNum: 1,
            allMoney: 0,
            loading: false,
            Limit: 10,
            customerList: [],
            codeList: [],
            nameList: [],
            seriesList: [],
            dataList: [],
            pageTitle: '',
            eyeHistoryVisible: false,
            goodsAnalysisVisible: false,
            SalesDataVisible: false,
            SaleDialogTitle: '',
            SalesDataTitle: '',
            changeCodeConfig: false,
            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            selectedData: [],
            priceCanBeZero: false,
            isUpperLimit: false,
            // 搜索配件弹框返回参数
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 500,
                // 总数量
                _totalCount: 0,
                showPerc: false //是否展示百分比
            },
            EntpCusId: '',
            EntpCusName: '',
            isBPriceShow: false,
            isOriginShow: false, //产地
            isSizeShow: false, //规格
            dataindex: 0,
            currentRow: {},
            SalesDataHeader: [],
            SalesDataList: [],
            warehouseList: [],
            warehouseId: '',
            warehouseName: '',
            isPlanCountShow: false,
            permission: {},
            isShowBrand: false, //是否显示品牌
            isLatelyPrice: false,
            // 汽配编码排序标识
            sortActive: '',
            // 用于供应商列表，分页搜索功能
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        let that = this;
        that.permission = that.$util.getPermission('urgentGoodsPur');
        document.addEventListener('keydown', that.handleKeyEvent);
    },
    mounted() {
        let that = this;
        // let localStorage = null;
        this.getConfigByCodes();

        //判断是否有保存草稿数据
        if (that.permission.saveTemp) {
            that.checkTempData().then(result => {
                if (result) {
                    that.$confirm('检测到当前还有未完成编辑急件采购明细，是否继续编辑未完成的订单明细', '', {
                        type: 'error',
                        distinguishCancelAndClose: true,
                        confirmButtonText: '继续编辑', //确认按钮文字更换
                        cancelButtonText: '新增明细', //取消按钮文字更换
                        showClose: true
                    })
                        .then(() => {
                            let datalist = JSON.parse(result);
                            if (datalist && datalist.length > 0) {
                                let _allNum = 0;
                                let _allMoney = 0;
                                for (let i = 0; i < datalist.length; i++) {
                                    _allNum += Number(datalist[i].Count);
                                    _allMoney += datalist[i].Count * datalist[i].Price ? datalist[i].Count * datalist[i].Price : 0;
                                }
                                that.allMoney = _allMoney;
                                that.allNum = _allNum;
                                that.dataList = datalist;
                                // that.updateInvens();
                                let mw = datalist[0];
                                if (mw) {
                                    that.warehouseList.push({
                                        WarehouseId: mw.WarehouseId,
                                        WarehouseName: mw.WarehouseName
                                        //  Address: mw.Address,
                                        //  Type: mw.WarehouseType
                                    });
                                    that.warehouseId = mw.WarehouseId;
                                    that.warehouseName = mw.WarehouseName;
                                }
                            }
                        })
                        .catch(() => {
                            that.checkPageChace();
                        });
                } else {
                    that.checkPageChace();
                }
            });
        } else {
            that.checkPageChace();
        }
        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);
        window.onresize = () => {
            this.resetHeight();
        };
        setTimeout(() => {
            this.resetHeight();
        }, 0);
    },
    computed: {
        // 列表高度
        infiniteTableHeight() {
            let bottomHeight = 38;
            return this.infiniteListHeight - bottomHeight;
        },
        showIconDelete() {
            return this.dataList.length !== 1;
        },
        showIconAdd() {
            return function (rowIndex) {
                return rowIndex + 1 === this.dataList.length;
            };
        }
    },
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = [
                    'ddhhm',
                    'xsspjgwl',
                    'cgsxxz',
                    // 'xskdxskdj',
                    // 'kdspcd',
                    //  'kdspgg',
                    //   'dgyscgjhs',
                    //   'kdxspp',
                    'xzqpbmdwyx'
                    // 'dgystjqzdjg'
                ];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'ddhhm':
                                    this.changeCodeConfig = result;
                                    break;
                                case 'xsspjgwl':
                                    this.priceCanBeZero = result;
                                    break;
                                case 'cgsxxz':
                                    this.isUpperLimit = result;
                                    break;
                                case 'xskdxskdj': //本来用于开单价的，后面统一是开单价及产地等其他的展示
                                    this.isBPriceShow = result;
                                    break;
                                // case 'kdspcd': //是否出现产地
                                //     this.isOriginShow = result;
                                //     break;
                                // case 'kdspgg': //是否出现规格
                                //     this.isSizeShow = result;
                                //     break;
                                case 'dgyscgjhs': //是否展示计划数
                                    this.isPlanCountShow = result;
                                    break;
                                // case 'kdxspp': //是否显示品牌
                                //     this.isShowBrand = result;
                                //     break;
                                case 'xzqpbmdwyx': //是否检测编码重复
                                    this.isCheckCode = result;
                                    break;
                                // case 'dgystjqzdjg': //是否只取相同最低价格取最新供应商（返回最低价格）
                                //     this.isLatelyPrice = result;
                                //     break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },
        // 搜索
        showSearch() {
            if (!this.warehouseId) {
                this.$util.warningMsg('请选择入仓仓库');
                return;
            }
            this.searchApParams = {
                _visible: false,
                showPerc: false,
                _percentage: 0,
                _totalCount: 0,
                IsFull: false
            };
            this.searchVisible = true;
        },
        // 搜索配件弹框 - 确认筛选结果按钮操作
        chooseAllAPsHandle(data) {
            this.searchVisible = false;
            this.searchApParams = {
                ...data.searchData,
                limit: this.searchApParams._limit,
                _visible: true,
                showPerc: false,
                _percentage: 0,
                _limit: this.searchApParams._limit,
                _totalCount: data.searchData.limit,
                IsFull: true
            };
            this.loopSearch();
        },
        // 开始循环
        async loopSearch() {
            const { data } = await this.$util.axiosPost({
                url: '/api/EntpPurchaseOrder/SearchSaleUrgentGoods',
                data: this.searchApParams,
                hideLoading: true
            });
            // this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);
            // this.searchApParams.page += 1;
            //这里是全查所以不用循环
            this.closeSearchDialog(data);
            // let _stop = !data || data.length < this.searchApParams._limit;
            // this.closeSearchDialog(data);
            // if (_stop) {
            //     this.searchApParams._percentage = 100;
            //     this.searchApParams._visible = false;
            // } else {
            //     this.loopSearch();
            // }
        },
        async closeSearchDialog(items) {
            let that = this;
            that.searchVisible = false;
            let itemList = [...items];
            if (itemList.length == 0) {
                that.searchVisible = false;
                return;
            }
            if (that.searchApParams._totalCount == 0) {
                that.searchApParams._totalCount = itemList.length;
            }
            let newGoodsList = [];
            that.searchApParams._visible = true;
            that.searchApParams.showPerc = true;
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                that.searchApParams._percentage = parseInt(((i + 1) / that.searchApParams._totalCount) * 100);

                let index = that.dataList.findIndex(x => x.OrderRsId == item.OrderRsId);
                if (index > -1) {
                    if (i == itemList.length - 1) {
                        that.searchApParams._visible = false;
                        that.searchApParams.showPerc = false;
                        that.searchApParams._percentage = 100;
                    }
                    continue;
                }
                let newGoods = {
                    EntpCusId: item.Supplier ? item.Supplier.EntpCusId : '',
                    EntpCusName: item.Supplier ? item.Supplier.EntpCusName : '',
                    EntpCusItem: item.Supplier ? item.Supplier.EntpCusName : '',
                    EntpTempGoodsId: item.EntpTempGoodsId,
                    APCode: item.APCode,
                    GoodName: item.GoodName,
                    GoodNameItem: item.GoodName,
                    AutoSerise: item.AutoSerise,
                    AutoSeriseItem: item.AutoSerise,
                    Count: item.Count,
                    Inventory: item.StorageInventory,
                    // Price: item.Price,
                    Price: item.CostPrice,
                    CostPrice: item.CostPrice,
                    Unit: item.Unit,
                    State: 0,
                    Size: item.Size,
                    Origin: item.Origin,
                    UpperLimit: item.UpperLimit,
                    Brand: item.Brand,
                    SalesPrice: item.SalesPrice,
                    SaleOrderCode: item.SaleOrderCode,
                    OrderRsId: item.OrderRsId,
                    WarehouseId: item.WarehouseId,
                    WarehouseName: item.WarehouseName
                };
                if (!newGoods.EntpCusId) {
                    let sameCust = newGoodsList.find(x => x.EntpTempGoodsId == newGoods.EntpTempGoodsId && x.EntpCusId);
                    if (!sameCust) sameCust = that.dataList.find(x => x.EntpTempGoodsId == newGoods.EntpTempGoodsId && x.EntpCusId);
                    if (sameCust) {
                        newGoods.EntpCusId = sameCust.EntpCusId;
                        newGoods.EntpCusName = sameCust.EntpCusName;
                        newGoods.EntpCusItem = sameCust.EntpCusName;
                        newGoods.Price = sameCust.Price;
                    } else {
                        //获取三个月最低价供应商
                        const { data } = await this.$util.axiosGet({
                            url: '/api/EntpPurchaseOrder/GetGoodsLatestPur',
                            data: { goodsId: newGoods.EntpTempGoodsId },
                            hideLoading: true
                        });
                        if (data) {
                            newGoods.EntpCusId = data.EntpCusId;
                            newGoods.EntpCusName = data.EntpCusName;
                            newGoods.EntpCusItem = data.EntpCusName;
                            newGoods.Price = data.Price;
                        }
                    }
                }
                newGoodsList.push(newGoods);
                if (i == itemList.length - 1) {
                    that.searchApParams._visible = false;
                    that.searchApParams.showPerc = false;
                }
            }
            if (!that.warehouseId) {
                let mw = newGoodsList[0];
                if (mw) {
                    that.warehouseList.push({
                        WarehouseId: mw.WarehouseId,
                        WarehouseName: mw.WarehouseName
                    });
                    that.warehouseId = mw.WarehouseId;
                    that.warehouseName = mw.WarehouseName;
                }
            }
            //判断最后一条数据是否空值，是的话移到最后
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }

            that.priceChange();
            this.addPageChace();

            that.$nextTick(() => {
                if (that.$refs['count' + (that.dataList.length - 1).toString()]) {
                    that.$refs['count' + (that.dataList.length - 1).toString()][0].focus();
                }
            });
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += Number(DetailList[i].Count * DetailList[i].Price ? (DetailList[i].Count * DetailList[i].Price).toFixed(3) : 0);
            }
            this.allMoney = _allMoney;
            this.allNum = _allNum;
            this.dataList = DetailList;
        },

        // 提交采购单
        submitForm() {
            let that = this;
            if (that.saving) {
                return;
            }
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].EntpCusId) {
                    that.$util.warningMsg('请填写供应商');
                    return;
                }
                if (!_dataList[i].APCode) {
                    that.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    that.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (!_dataList[i].Count || Number(_dataList[i].Count) < 0) {
                    that.$util.warningMsg('请填写正确的配件数量');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    that.$util.warningMsg('请填写车型');
                    return;
                }
                if (!that.priceCanBeZero) {
                    if (!_dataList[i].Price || _dataList[i].Price < 0) {
                        that.$util.warningMsg('请填写正确的采购价');
                        return;
                    }
                }
                _dataList[i].SortNum = i + 1;
            }
            that.saving = true;

            that.$confirm('急件采购单的商品入库状态默认已提交已入库，是否需要创建', '', {
                type: 'warning',
                distinguishCancelAndClose: true
            })
                .then(() => {
                    that.saveMuilPurOrders(_dataList);
                })
                .catch(() => {
                    that.saving = false;
                });

            // let checkRepeat = this.checkRepeatAndReturnData(_dataList);
            // if (checkRepeat.hasRepeat) {
            //     that.$confirm('订单含有重复商品项，是否需要累加', '', {
            //         type: 'error',
            //         distinguishCancelAndClose: true
            //     })
            //         .then(() => {
            //             // 覆盖数据
            //             //检查是否超过库存上限
            //             if (that.isUpperLimit) {
            //                 that.sumbit_ckeckIsOverLimit(checkRepeat.row);
            //             } else that.submitData(checkRepeat.row);
            //         })
            //         .catch(() => {
            //             that.saving = false;
            //         });
            // } else {
            //     if (that.isUpperLimit) {
            //         that.sumbit_ckeckIsOverLimit(_dataList);
            //     } else {
            //         that.submitData(_dataList);
            //     }

            // }
        },
        submitData(data) {
            let that = this;
            let ids = [];
            let firstId = '';
            let firstName = '';
            for (let i = 0; i < data.length; i++) {
                let id = data[i].EntpCusId;
                if (id) {
                    firstId = id;
                    firstName = data[i].EntpCusName;
                    let index = ids.findIndex(f => f === id);
                    if (index == -1) ids.push(id);
                } else {
                    data[i].EntpCusId = firstId;
                    data[i].EntpCusName = firstName;
                }
            }
            if (ids.length == 0) {
                that.$util.warningMsg('未检测到供应商');
                return;
            }
            that.saveMuilPurOrders(data);
        },
        saveMuilPurOrders(data) {
            let that = this;
            let HadSaveTempPer = that.permission.saveTemp != null && that.permission.saveTemp != '';
            that.$util
                .axiosPost({
                    url: '/api/EntpPurchaseOrder/AddUrgentSuPurOrders',
                    data: { HadSaveTempPer: HadSaveTempPer, WHId: that.warehouseId, GoodsList: data }
                })
                .then(() => {
                    that.$store.commit('updateNeedRefresh', true);
                    that.needConfirm = false;
                    that.$util.successMsg('保存采购订单成功');
                    that.removePageChace();

                    setTimeout(() => {
                        this.$router.push('/purchaseManage/urgentGoodsPur');
                    }, 2000);
                })
                .catch(() => {
                    this.saving = false;
                });
        },
        // 检查是否有重复项及返回已合并数量的数据
        checkRepeatAndReturnData(data) {
            let [list, row, hasRepeat] = [data, [], false];

            if (this.isCheckCode) {
                list.forEach(item => {
                    let index = row.findIndex(f => f.APCode === item.APCode && f.EntpCusId == item.EntpCusId);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            } else {
                list.forEach(item => {
                    let index = row.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId && f.EntpCusId == item.EntpCusId);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            }
            return {
                hasRepeat,
                row
            };
        },
        sumbit_ckeckIsOverLimit(data) {
            let that = this;
            let goodsList = [];
            data.forEach(item => {
                let i = goodsList.findIndex(f => f.APCode === item.APCode);
                if (i > -1) {
                    goodsList[i].Count += item.Count;
                } else {
                    goodsList.push(Object.assign({}, item));
                }
            });
            let index = goodsList.findIndex(f => Number(f.Count) + f.Inventory > f.UpperLimit);
            if (index > -1) {
                that.$confirm('订单含有商品采购总数已达预警上限，是否继续采购', '', {
                    type: 'error',
                    distinguishCancelAndClose: true
                })
                    .then(() => {
                        that.submitData(data);
                    })
                    .catch(() => {
                        that.saving = false;
                    });
            } else {
                that.submitData(data);
            }
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
            this.priceChange();
            this.addPageChace();
        },
        // 添加一行
        addItem(addPageChace) {
            let that = this;
            let _dataList = that.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].EntpCusId) {
                    that.$util.warningMsg('请填写供应商');
                    return;
                }
                if (!_dataList[i].APCode) {
                    that.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    that.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    that.$util.warningMsg('请填写车型');
                    return;
                }
                if (!that.priceCanBeZero) {
                    if (!_dataList[i].Price || _dataList[i].Price < 0) {
                        that.$util.warningMsg('请填写正确的采购价');
                        return;
                    }
                }
            }
            if (addPageChace) {
                that.addPageChace(); //添加销售订单缓存
            }

            let newGoods = {
                EntpCusId: '',
                EntpCusName: '',
                EntpCusItem: '',
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                GoodNameItem: '',
                AutoSerise: '',
                AutoSeriseItem: '',
                Count: 1,
                Inventory: 0,
                NeedOut: 0,
                NeedIn: 0,
                Price: 0,
                CostPrice: '',
                Unit: '',
                State: 0,
                UpperLimit: 0,
                Origin: '',
                Size: ''
            };
            that.dataList.push(newGoods);
            that.priceChange();

            setTimeout(() => {
                that.$refs.infiniteTable.scrollToRow(that.dataList[that.dataList.length - 1]);
                that.$refs.infiniteTable.setActiveRow(that.dataList[that.dataList.length - 1]);
                if (that.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('business-content')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);
        },
        // 点击展开下拉框
        focusHandle(index, type) {
            // if (type === 'custSelect') {
            //     setTimeout(() => {
            //         this.$refs[`custSelect`].focus();
            //     }, 200);
            //     return;
            // }
            // if (type === 'code') {
            //     setTimeout(() => {
            //         this.$refs[`code`].focus();
            //     }, 200);
            //     return;
            // }
            // if (type === 'partsNameSelect') {
            //     setTimeout(() => {
            //         this.$refs[`partsNameSelect`].focus();
            //     }, 200);
            //     return;
            // }
            // if (type === 'autoSeriseSelect') {
            //     setTimeout(() => {
            //         this.$refs[`autoSeriseSelect`].focus();
            //     }, 200);
            //     return;
            // }
            // if (type === 'unitSelect') {
            //     setTimeout(() => {
            //         this.$refs[`unitSelect`].focus();
            //     }, 200);
            //     return;
            // }
        },

        // 供应商改变
        customerChange(item, index) {
            let that = this;
            if (!item) {
                that.dataList[index].EntpCusId = '';
                that.dataList[index].EntpCusName = '';
                // that.dataList[index].Price = that.dataList[index].CostPrice;
            } else if (typeof item == 'string') {
                that.dataList[index].EntpCusName = item.EntpCusName;
            } else {
                that.dataList[index].EntpCusId = item.EntpCusId;
                that.dataList[index].EntpCusName = item.EntpCusName;
                if (that.dataList[index].EntpTempGoodsId) {
                    that.getGoodsLatestPrice(item.EntpCusId, that.dataList[index].EntpTempGoodsId).then(resp => {
                        if (resp && Number(resp.Price) > 0) {
                            that.dataList[index].Price = Number(resp.Price);
                        }
                        // else {
                        //     that.dataList[index].Price = that.dataList[index].CostPrice;
                        // }
                    });
                }
            }
        },
        //当供应商下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.codeList.length == 0) that.searchCode('');
            }
        },
        //当汽配件名称下拉框出现时触发
        apNameVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.nameList.length == 0) that.searchName('');
            }
        },
        //当车系下拉框出现时触发
        autoSeriseVisibleChange(event, item) {
            let that = this;
            if (event) {
                if (that.seriesList.length == 0) that.searchAutoSerie('', item);
            }
        },
        // 历史销售
        showHistories(row) {
            if (row.EntpTempGoodsId) {
                this.EntpTempGoodsIdEdit = row.EntpTempGoodsId;
                this.EntpCusId = row.EntpCusId;
                this.EntpCusName = row.EntpCusName;
                this.historyVisible = true;
            }
        },
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.EntpTempGoodsIdEdit = row.EntpTempGoodsId;
                this.EntpCusId = row.EntpCusId;
                this.EntpCusName = row.EntpCusName;
                this.eyeHistoryVisible = true;
            }
        },
        analysis(row) {
            if (row) {
                this.EntpTempGoodsIdEdit = row.EntpTempGoodsId;
                this.goodsAnalysisVisible = true;
            }
        },
        // 设置展示合计数据行
        setSummaries(param) {
            // return [['', '', '', '总数量', this.allNum, '', '合计', this.allMoney.toFixed(3), '', '']];
            var countColIndex = 0;
            var sumColIndex = 0;
            countColIndex = param.columns.findIndex(item => {
                return item.title == '急件数';
            });
            sumColIndex = param.columns.findIndex(item => {
                return item.title == '采购总价';
            });

            var arr = new Array(param.columns.length);
            if (countColIndex != -1) {
                arr[countColIndex] = this.allNum;
                arr[countColIndex - 1] = '总数量';
            }
            if (sumColIndex != -1) {
                arr[sumColIndex] = this.allMoney.toFixed(3);
                arr[sumColIndex - 1] = '合计';
            }
            return [arr];
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = [];
            if (this.isCheckCode) rowArr = this.dataList.filter(f => f.APCode === row.APCode && f.EntpCusId === row.EntpCusId);
            else rowArr = this.dataList.filter(f => f.EntpTempGoodsId === row.EntpTempGoodsId && f.EntpCusId === row.EntpCusId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        //判断是否有缓存,加载缓存或者请求订单信息
        loadStorage() {
            let datalist = this.$util.getLocalStorage(this.dataStorageName);
            if (datalist && datalist.length > 0) {
                return {
                    list: datalist
                };
            } else {
                return null;
            }
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$util.setLocalStorage(this.dataStorageName, this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage(this.dataStorageName);
        },
        //从缓存中读取数据
        async getDataFromChace(_data) {
            let that = this;
            let datalist = _data.list;
            if (datalist && datalist.length > 0) {
                let _allNum = 0;
                let _allMoney = 0;
                for (let i = 0; i < datalist.length; i++) {
                    let item = datalist[i];
                    _allNum += Number(item.Count);
                    _allMoney += item.Count * item.Price ? item.Count * item.Price : 0;
                    that.searchApParams._percentage = parseInt(((i + 1) / datalist.length) * 100);
                    if (i == 0) {
                        that.searchApParams._visible = true;
                        that.searchApParams.showPerc = true;
                    }
                    if (!item.EntpCusId) {
                        let sameCust = datalist.find(x => x.EntpTempGoodsId == item.EntpTempGoodsId && x.EntpCusId);
                        if (sameCust) {
                            item.EntpCusId = sameCust.EntpCusId;
                            item.EntpCusName = sameCust.EntpCusName;
                            item.EntpCusItem = sameCust.EntpCusName;
                            item.Price = sameCust.Price;
                        } else {
                            //获取三个月最低价供应商
                            const { data } = await this.$util.axiosGet({
                                url: '/api/EntpPurchaseOrder/GetGoodsLatestPur',
                                data: { goodsId: item.EntpTempGoodsId },
                                hideLoading: true
                            });
                            if (data) {
                                item.EntpCusId = data.EntpCusId;
                                item.EntpCusName = data.EntpCusName;
                                item.EntpCusItem = data.EntpCusName;
                                item.Price = data.Price;
                            }
                        }
                    }
                    if (i == datalist.length - 1) {
                        that.$nextTick(() => {
                            setTimeout(function () {
                                that.searchApParams._visible = false;
                                that.searchApParams.showPerc = false;
                            }, 200);
                        });
                    }
                }
                that.allMoney = _allMoney;
                that.allNum = _allNum;
                that.dataList = datalist;
                //  this.updateInvens();
                let mw = datalist[0];
                if (mw) {
                    that.warehouseList.push({
                        WarehouseId: mw.WarehouseId,
                        WarehouseName: mw.WarehouseName
                        //  Address: mw.Address,
                        //  Type: mw.WarehouseType
                    });
                    that.warehouseId = mw.WarehouseId;
                    that.warehouseName = mw.WarehouseName;
                }
            }
        },

        // // 搜索顾客
        // searchCustomer(key) {
        //     this.loading = true;
        //     this.customerList = [];
        //     this.$util.searchSupplier(key).then(data => {
        //         this.loading = false;
        //         this.customerList = this.$util.uniqueArr(this.customerList, data);
        //     });
        // },
        // 搜索供应商，分页
        searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.customerList = [];
            }
            if (this.supplierForm.stopLoad) return;
            this.loading = true;
            this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit).then(data => {
                this.loading = false;
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.customerList = this.$util.uniqueArr(this.customerList, data);
            });
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchCustomer();
        },
        // 搜索汽配编码
        searchCode(key) {
            this.loading = true;
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpGoods/GetGoodsSelItemsForMultiPur',
                        data: {
                            APCode: key,
                            SId: this.warehouseId,
                            Limit: this.Limit
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.loading = false;
                        this.codeList = res.data ? res.data : [];
                        resolve();
                    });
            });
        },
        // 搜索名称
        searchName(key, item) {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForMultiPur',
                    data: {
                        GoodName: key,
                        SId: this.warehouseId,
                        Limit: this.Limit
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    this.nameList = res.data ? res.data : [];
                    if (item) {
                        item.VGoodName = key;
                        item.GoodName = key;
                        this.seriesList = res.data;
                    }
                });
        },
        // 搜车系
        searchAutoSerie(key, item) {
            this.loading = true;
            this.$util
                .axiosGet({
                    // url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder',
                    url: '/api/EntpGoods/GetGoodsSelItemsForMultiPur',
                    data: {
                        GoodName: item ? item.VGoodName : '', //配合商品名称查
                        Limit: this.Limit,
                        SId: this.warehouseId,
                        OnlySeries: true,
                        SeriesName: key
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    this.seriesList = res.data ? res.data : [];
                });
        },
        //检查是否超出上限
        ckeckIsOverLimit(goods) {
            if (!this.isUpperLimit) return false;
            //相同编码的商品都要计算
            let count = 0;
            this.dataList.forEach(item => {
                if (item.APCode == goods.APCode) count += item.Count;
            });
            return count + goods.Inventory > goods.UpperLimit;
        },
        getGoodsLatestPrice(sId, id) {
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpPurchaseOrder/GetGoodsLatestPriceBySId',
                        data: {
                            sId: sId,
                            id: id
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        resolve(res.data);
                    });
            });
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },
        //获取商品近三个月的出库数据记录
        getGoodsLatestOutRecord(id) {
            let that = this;
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpSaleOrder/GetLatelySalesOutData',
                        data: {
                            goodsId: id,
                            sId: that.warehouseId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        resolve(res.data);
                    });
            });
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            this.dataindex = row.index;
            this.currentRow = row;
        },
        cellClick(row, column, cell, event) {
            // if (column.property === 'EntpCusItem') {
            //     setTimeout(() => {
            //         this.$refs[`custSelect`].focus();
            //     }, 200);
            //     return;
            // }
            // if (column.property === 'APCode') {
            //     setTimeout(() => {
            //         this.$refs[`code`].focus();
            //     }, 200);
            //     return;
            // }
            // if (column.property === 'GoodName') {
            //     setTimeout(() => {
            //         this.$refs[`partsNameSelect`].focus();
            //     }, 200);
            //     return;
            // }
            // if (column.property === 'AutoSeriseItem') {
            //     setTimeout(() => {
            //         this.$refs[`autoSeriseSelect`].focus();
            //     }, 200);
            //     return;
            // }
            // if (['Origin', 'Count', 'Price'].includes(column.property)) {
            //     return;
            // }
            // if (column.property && row.EntpTempGoodsId) {
            //     this.getGoodsLatestOutRecord(row.EntpTempGoodsId).then(data => {
            //         if (data) {
            //             this.SalesDataTitle = `商品编码【${row.APCode}】`;
            //             this.SalesDataList = [{ list: data.list }];
            //             this.SalesDataHeader = data.header;
            //             this.SalesDataVisible = true;
            //             if (this.$refs.salesDataTable) this.$refs.salesDataTable.refreshColumn();
            //         }
            //     });
            // }
        },
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            if (key === 13) {
                if (that.searchVisible) {
                    that.$refs.searchDlg.handleSearch();
                }
            }
            if (key === 27) {
                //Esc
                e.preventDefault();
                if (that.searchVisible) {
                    that.$refs.searchDlg.keyESCFunc();
                    //that.searchVisible = false;
                    return;
                } else that.SalesDataVisible = false;
                return;
            }
            //下键
            if (key == 40) {
                that.canSearch = true;
                if (!that.searchVisible && !that.searchItemVisible) {
                    if (!that.APMsgVisible && !that.saving && !that.eyeHistoryVisible && !that.goodsAnalysisVisible) {
                        e.preventDefault();
                        //光标已经在编辑框内，不可上下移动
                        var cursorFocus = document.querySelector('input:focus');
                        if (cursorFocus) {
                            return;
                        }
                        if (that.dataindex != that.dataList.length - 1) {
                            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                                that.dataindex++;
                            } else that.dataindex = 0;
                            let index = that.dataindex;
                            that.$nextTick(() => {
                                if (that.$refs.infiniteTable) {
                                    that.currentRow = that.$refs.infiniteTable.data[index];
                                    that.$refs.infiniteTable.setCurrentRow(that.$refs.infiniteTable.data[index]);
                                    if (that.currentRow.EntpTempGoodsId) {
                                        this.getGoodsLatestOutRecord(that.currentRow.EntpTempGoodsId).then(data => {
                                            if (data) {
                                                this.SalesDataTitle = `商品编码【${that.currentRow.APCode}】`;
                                                this.SalesDataList = [{ list: data.list }];

                                                this.SalesDataHeader = data.header;
                                                this.SalesDataVisible = true;
                                            }
                                        });
                                    }
                                }
                            });
                        }

                        return;
                    }
                } else {
                    e.preventDefault();
                    if (that.$refs.searchDlg) {
                        that.$refs.searchDlg.keyDownFunc();
                    }
                    return;
                }
                return;
            }
            //上键
            if (key == 38) {
                that.canSearch = true;
                if (!that.searchVisible && !that.searchItemVisible) {
                    if (!that.APMsgVisible && !that.saving && !that.eyeHistoryVisible && !that.goodsAnalysisVisible) {
                        e.preventDefault();
                        //光标已经在编辑框内，不可上下移动
                        cursorFocus = document.querySelector('input:focus');
                        if (cursorFocus) {
                            return;
                        }
                        if (that.dataindex != 0) {
                            that.dataindex--;
                            let index = that.dataindex;
                            that.$nextTick(() => {
                                if (that.$refs.infiniteTable) {
                                    that.currentRow = that.$refs.infiniteTable.data[index];
                                    that.$refs.infiniteTable.setCurrentRow(that.$refs.infiniteTable.data[index]);
                                    if (that.currentRow.EntpTempGoodsId) {
                                        this.getGoodsLatestOutRecord(that.currentRow.EntpTempGoodsId).then(data => {
                                            if (data) {
                                                this.SalesDataTitle = `商品编码【${that.currentRow.APCode}】`;
                                                this.SalesDataList = [{ list: data.list }];

                                                this.SalesDataHeader = data.header;
                                                this.SalesDataVisible = true;
                                            }
                                        });
                                    }
                                }
                            });
                        }

                        return;
                    }
                } else {
                    e.preventDefault();
                    if (that.$refs.searchDlg) {
                        that.$refs.searchDlg.keyUpFunc();
                    }
                    return;
                }
                return;
            }
            if (key === 107 || key === 187) {
                // if (!that.searchVisible) that.addItem(false);
            }
            if (key == 112) {
                //F1
                e.preventDefault();
                if (that.searchVisible) return;
                that.saveTemp();
                return;
            }
            if (key == 113) {
                e.preventDefault();
                if (!this.warehouseId) {
                    this.$util.warningMsg('请选择入仓仓库');
                    return;
                }
                if (!that.searchVisible) that.searchVisible = true;
                else if (that.searchVisible && !that.searchItemVisible) that.$refs.searchDlg.showSearchItem();
            }
            //F3
            if (key == 114) {
                e.preventDefault();
                if (that.searchVisible) that.$refs.searchDlg.showHistories();
            }
            if (key == 115) {
                e.preventDefault();
                if (that.searchVisible) that.$refs.searchDlg.showReHistories();
            }
            if (key == 116) {
                e.preventDefault();
                if (that.searchVisible) that.$refs.searchDlg.showSaleStat();
            }
            if (key == 117) {
                e.preventDefault();
                if (that.searchVisible) that.$refs.searchDlg.showSaleReStat();
            }
            if (key == 118) {
                e.preventDefault();
                if (that.searchVisible) that.$refs.searchDlg.analysis();
            }
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) {
                    this.$util.getWarehouse(1).then(data => {
                        this.warehouseList = data;
                    });
                }
            }
        },
        warehouseChange(val) {
            let that = this;
            if (val) {
                let w = that.warehouseList.find(e => e.WarehouseId == val);
                if (w) {
                    // that.$util.setLocalStorage('muilpurWarehouses', w);
                    that.warehouseName = w.WarehouseName;
                    // that.updateInvens();
                }
            }
        },
        updateInvens() {
            let that = this;
            if (that.warehouseId) {
                // 查询在这个仓库下的商品库存
                if (that.dataList) {
                    let ids = [];
                    that.dataList.forEach((e, i) => {
                        if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
                    });
                    if (ids.length > 0) {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/GetGoodsStoragesInventorys',
                                data: {
                                    sId: that.warehouseId,
                                    ids: ids
                                }
                            })
                            .then(res => {
                                let data = res.data;
                                that.dataList.forEach((e, i) => {
                                    let getStorage = data.find(d => d.GoodsId == e.EntpTempGoodsId);
                                    if (getStorage) {
                                        e.Inventory = getStorage.Count;
                                        e.NeedOut = getStorage.OrderWaitOutQuantity;
                                        e.NeedIn = getStorage.POrderWaitInQuantity;
                                    } else {
                                        e.Inventory = 0;
                                        e.NeedOut = 0;
                                        e.NeedIn = 0;
                                    }
                                });
                            })
                            .catch(() => {});
                    }
                }
            }
        },
        setItemVisible(visible) {
            this.searchItemVisible = visible;
        },
        //检测草稿数据
        checkTempData() {
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpPurchaseOrder/GetTempUrgentSuPurOrders',
                        hideLoading: false
                    })
                    .then(res => {
                        resolve(res.data);
                    });
            });
        },
        //检测并初始化页面缓存数据
        checkPageChace() {
            let that = this;
            let localStorage = null;
            //判断缓存是否有数据，如果有取缓存数据
            localStorage = that.loadStorage();
            if (localStorage) {
                that.getDataFromChace(localStorage);
            }
            // if (that.dataList.length == 0) {
            //     that.addItem(false);
            // }
        },
        //保存为草稿
        saveTemp() {
            let that = this;
            let datalist = that.dataList;
            if (!(datalist && datalist.length)) {
                that.$util.warningMsg('没有可保存的数据');
                return;
            }
            let _tempData = JSON.stringify(datalist);
            this.saving = true;
            that.$util
                .axiosPost({
                    url: '/api/EntpPurchaseOrder/AddTempUrgentSuPurOrders',
                    data: { Value: _tempData }
                })
                .then(() => {
                    that.$store.commit('updateNeedRefresh', true);
                    that.needConfirm = false;
                    that.$util.successMsg('临时保存成功');
                    that.removePageChace();

                    setTimeout(() => {
                        this.$router.push('/purchaseManage/urgentGoodsPur');
                    }, 2000);
                })
                .catch(() => {
                    this.saving = false;
                });
        },
        changeTableSort(type, prop) {
            if (prop != 'PlanPurchase') {
                let sortArr = [];
                let listArr = this.dataList.filter(f => f[prop]);
                let otherArr = this.dataList.filter(f => !f[prop]);
                if (type === 'top') {
                    this.sortActive = 'top';
                    sortArr = listArr.sort((a, b) => a[prop].localeCompare(b[prop]));
                } else {
                    this.sortActive = 'bottom';
                    sortArr = listArr.sort((a, b) => b[prop].localeCompare(a[prop]));
                }
                this.dataList = [...sortArr, ...otherArr];
            } else {
                let _datalist = this.dataList;
                if (type === 'top') {
                    _datalist.sort(function (a, b) {
                        return a.PlanPurchase - b.PlanPurchase;
                    });
                } else {
                    _datalist.sort(function (a, b) {
                        return b.PlanPurchase - a.PlanPurchase;
                    });
                }
            }
        }
    }
};
</script>
<style lang="less" scoped>
.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}

.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 20px;
    margin-bottom: 20px;
}

.form-main {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}

.form-bottom {
    width: 100%;
    display: flex;
    flex-direction: row;

    div {
        width: 50%;
    }
}

.form-applyzone {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}

.form-account {
    width: 57.7%;
    float: left;
    margin-left: 30px;
    border: 1px dashed #888888;
    border-radius: 10px;
}

.inventory-title {
    line-height: 1.2;
    flex-direction: column;

    > div:nth-child(1) {
        width: 100%;
        border-bottom: 1px solid @border3Color;
    }

    > div:nth-child(2) {
        width: 100%;
        display: flex;

        > div {
            width: 33.33%;
        }
    }
}

.form-section {
    display: flex;
}

.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}

.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}

.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
}

.btn-ctn {
    margin-right: 110px;
    padding: 30px 0;
    text-align: right;
    padding-bottom: 180px;
}

.add-btn {
    position: absolute;
    right: 2%;
    bottom: 0;
}

.less-btn {
    position: absolute;
    right: -40px;
    top: 2px;
    z-index: 2;
}

.table-main {
    position: relative;
}

.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}

.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}

.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.table-item {
    height: 50px;
    position: relative;
}

.div-table-row {
    overflow: inherit;
    margin: -1px -1px -1px 0px;
}

.div-table-cell-code {
    position: relative;

    .row-delete {
        position: absolute;
        padding: 1px 6px;
        top: 0;
        right: 0;
        color: #fff;
        background: #ffcc66;
        border-radius: 12.5px;
    }
}

.addresscls {
    display: flex;
    flex-direction: row;
}

.addicon {
    height: 30px;
    margin-left: 10px;
    margin-top: 5px;
}

.operate {
    height: 30px;
    // > i {
    //   margin-top: 8.5px;
    //   margin-right: 10px;
    //   cursor: pointer;
    // }
    display: flex;
    align-items: center;

    .el-icon-delete {
        margin-right: 8px;
        cursor: pointer;
    }

    .el-icon-plus {
        margin-right: 8px;
        cursor: pointer;
    }

    .image-sup {
        width: 27px;
        height: 27px;
        margin-right: 2px;
    }

    .image-cus {
        width: 26px;
        height: 26px;
    }
}

.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}

#ap-image-dialog {
    position: absolute;
    top: 10%;
    left: 10%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .image-item-dialog {
        width: 120px;
        height: 120px;
    }

    .el-dialog__body {
        padding: 0 !important;
        overflow: auto;
    }
}
</style>
<style lang="less">
.el-row {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 20px;
    }
}

.el-col {
    border-radius: 4px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}

.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}

.urgentGoodsToPur {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }

        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }

                .div-padding-12 {
                    padding: 4px 12px 0;
                }

                .operate {
                    padding: 0 12px;
                }

                .text-btn {
                    button {
                        padding-left: 0;
                        padding-right: 0;
                    }
                }

                td {
                    height: 26px;
                }
            }

            .elx-cell {
                padding: 0;
                height: 32px;
            }

            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }

        .elx-table--footer-wrapper {
            margin-top: 0 !important;

            .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }

        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }

    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }

        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }

        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }

    .special-border {
        height: 100%;
        border-radius: 3px;
        border: 1px solid #ffcc00;
    }

    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }

        .info-icon {
            vertical-align: top;
            margin-top: 2px;
            margin-right: 5px;
        }
    }

    .upperLimitWarning {
        .el-input__inner {
            border: 1px solid #e6a23c;
        }
    }
    .head-view {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .color-red {
            margin-right: 4px;
        }

        .sort-view {
            display: flex;
            flex-direction: column;

            i {
                line-height: 8px;
                cursor: pointer;
            }

            .active {
                color: #409eff;
            }
        }
    }
}
</style>
